import React, { useEffect, useRef, useState } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import moment from 'moment';
import _ from 'lodash';
import { withStyles } from '@mui/styles';
import { getConnectorScoreHistory } from './ConnectorService';
import { PubSub } from '../../utils/eventUtils';

const SecurityStudioScoreHistory = ({
  classes,
  connectorType,
  connectorId,
  days,
  q,
}: any) => {
  const [myData, setMyData] = useState(null);
  const options = {
    chart: {
      type: 'line',
      height: '165px',
    },
    yAxis: {
      title: {
        text: '',
      },
      max: 850,
      lineColor: '#9192a4',
      lineWidth: 1,
      labels: {
        style: {
          color: '#c9cdd9',
        },
      },
    },
    title: {
      text: '',
    },
    xAxis: {
      type: 'datetime',
    },
    series: [],
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    responsive: true,
  };

  const chartRef = useRef(null);

  useEffect(() => {
    const sub = PubSub.subscribe(
      'ConnectorDetails:toggleLines',
      (data: any) => {
        const { chart } = chartRef.current;
        const keys = Object.keys(data);
        keys.forEach((item, idx) => {
          chart.series[idx].setVisible(data[item]);
        });
      }
    );

    Promise.all([
      getConnectorScoreHistory({ connectorType, connectorId, days }),
    ])
      .then((responses) => {
        const scoresHistory = responses[0].data.histogram;
        setMyData({
          scoresHistory,
        });
      })
      .catch(console.error.bind(console));

    return () => {
      sub.remove();
    };
  }, [q.before, q.after, connectorType, connectorId, days]);

  const renderScoreHistorySection = () => {
    if (myData && myData.scoresHistory) {
      const { scoresHistory } = myData;
      const temp = {
        total: {
          name: '<span style="color: #fbc000;">Total Score</span>',
          data: [],
          color: '#fbc000',
        },
        administrativeControlScore: {
          name: '<span style="color: #fa8072;">Administrative</span>',
          data: [],
          color: '#fa8072',
        },
        physicalControlScore: {
          name: '<span style="color: #69a8e8;">Physical</span>',
          data: [],
          color: '#69a8e8',
        },
        internalTechnicalControlScore: {
          name: '<span style="color: #cce30e;">Internal</span>',
          data: [],
          color: '#cce30e',
        },
        externalTechnicalControlScore: {
          name: '<span style="color: #fbc5bf;">External</span>',
          data: [],
          color: '#fbc5bf',
        },
      };

      scoresHistory.forEach((item: any) => {
        const { time } = item;

        _.forEach(item, (value, key) => {
          if (typeof value === 'object') {
            if (key === 'totalScore') {
              if (value.value === null) {
                temp.total.data.push([
                  moment.utc(time).valueOf(),
                  temp.total.data[temp.total.data.length - 1][1],
                ]);
              } else {
                temp.total.data.push([moment.utc(time).valueOf(), value.value]);
              }
            }

            if (key === 'administrativeControlScore') {
              if (value.value === null) {
                temp.administrativeControlScore.data.push([
                  moment.utc(time).valueOf(),
                  temp.administrativeControlScore.data[
                    temp.administrativeControlScore.data.length - 1
                  ][1],
                ]);
              } else {
                temp.administrativeControlScore.data.push([
                  moment.utc(time).valueOf(),
                  value.value,
                ]);
              }
            }

            if (key === 'physicalControlScore') {
              if (value.value === null) {
                temp.physicalControlScore.data.push([
                  moment.utc(time).valueOf(),
                  temp.physicalControlScore.data[
                    temp.physicalControlScore.data.length - 1
                  ][1],
                ]);
              } else {
                temp.physicalControlScore.data.push([
                  moment.utc(time).valueOf(),
                  value.value,
                ]);
              }
            }

            if (key === 'internalTechnicalControlScore') {
              if (value.value === null) {
                temp.internalTechnicalControlScore.data.push([
                  moment.utc(time).valueOf(),
                  temp.internalTechnicalControlScore.data[
                    temp.internalTechnicalControlScore.data.length - 1
                  ][1],
                ]);
              } else {
                temp.internalTechnicalControlScore.data.push([
                  moment.utc(time).valueOf(),

                  value.value,
                ]);
              }
            }

            if (key === 'externalTechnicalControlScore') {
              if (value.value === null) {
                temp.externalTechnicalControlScore.data.push([
                  moment.utc(time).valueOf(),
                  temp.externalTechnicalControlScore.data[
                    temp.externalTechnicalControlScore.data.length - 1
                  ][1],
                ]);
              } else {
                temp.externalTechnicalControlScore.data.push([
                  moment.utc(time).valueOf(),
                  value.value,
                ]);
              }
            }
          }
        });
      });
      options.series.push(temp.total);
      options.series.push(temp.administrativeControlScore);
      options.series.push(temp.physicalControlScore);
      options.series.push(temp.internalTechnicalControlScore);
      options.series.push(temp.externalTechnicalControlScore);
      return (
        <HighchartsReact
          ref={chartRef}
          highcharts={Highcharts}
          options={options}
        />
      );
    }
    return (
      <img src="images/loading.svg" alt="" className={classes.loadingIcon} />
    );
  };

  if (myData) {
    return (
      <section className={classes.scoreHistoryContainer}>
        {renderScoreHistorySection()}
      </section>
    );
  }
  return null;
};

const styles = {
  chartsContainer: {
    width: '100%',
    height: '100%',
  },
  scoreHistoryContainer: {
    width: '100%',
    height: '100%',
    '& .highcharts-legend-item .highcharts-graph': {
      display: 'none',
    },
  },
};

export default withStyles(styles, { withTheme: true })(
  SecurityStudioScoreHistory
);
